import HeroCarousel from './components/HeroCarousel';
import QuickEpisodes from './components/QuickEpisodes';
import HotRecommendations from './components/HotRecommendations';
import SiteIntro from './components/SiteIntro';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function Home() {
  usePageMeta({
    title: '无颜之月动漫第一季全集－动画完整版在线观看平台',
    description:
      '无颜之月动漫第一季全集提供精彩动画内容，涵盖所有剧情和角色介绍，方便动漫爱好者免费播放、查找剧情信息。',
    keywords: '无颜之月动漫,动漫第一季全集,无颜之月动画,动漫在线观看,动漫剧情,动漫视频平台,全集动漫',
  });

  return (
    <div className="w-full">
      <HeroCarousel />
      <QuickEpisodes />
      <HotRecommendations />
      <SiteIntro />
    </div>
  );
}